export const PATH_PARAM = {
  SILO_ID: ':siloID',
  SILO_IDS: ':siloIDS',
  USER_ID: ':userID',
};

export const PATH_SEG = {
  // [PUBLIC]
  AUTH: 'auth',
  SILOREAL_LOGIN: 'siloreal-login',
  SIGNIN_OPTIONS: 'signin-options',
  CALLBACK: 'callback',
  ONBOARDING: 'onboarding',

  REGISTER: 'register',
  RESET: 'reset',
  PASSWORD: 'password',
  VERIFY: 'verify',
  COMPLETE: 'complete',

  GO: 'go',
  PLASTAR: 'plastar',
  NERA: 'nera',

  ERROR: 'error',

  // [PRIVATE]
  DASHBOARD: 'dashboard',
  USER_NOTIFICATION: 'user-notification',

  SILOBAG: 'silobag',
  SILOBAG_LIST: 'silobag-list',
  NEW: 'new',
  INSURANCE: 'insurance',
  CORVUS: 'corvus',
  ARCHIVED: 'archived',
  EDIT: 'edit',

  REPORT: 'report',
  STOCK: 'stock',
  ALERT: 'alert',
  DEVICE: 'device',
  STATE_STOCK: 'state-stock',
  ACTIVITY: 'activity',
  EXISTENCE_REPORT: 'existence-report',
  POSITION_GENERAL: 'position-general',

  MAP: 'map',

  INCONSISTENCIES: 'inconsistencies',

  ADMIN: 'admin',
  NOTIFICATION: 'notification',
  METRIC_ALERT_CONFIG: 'metric-alerts-config',
  WARRANTS: 'warrants',

  NO_CONNECTION: 'no-connection',
} as const;

export const VERSION = {
  V2: 'v2',
} as const;

export const PATH = {
  // [PUBLIC]
  AUTH_SILOREAL_LOGIN: `/${PATH_SEG.AUTH}/${PATH_SEG.SILOREAL_LOGIN}`,
  AUTH_SIGNIN_OPTIONS: `/${PATH_SEG.AUTH}/${PATH_SEG.SIGNIN_OPTIONS}`,
  AUTH_CALLBACK: `/${PATH_SEG.AUTH}/${PATH_SEG.CALLBACK}`,
  AUTH_ONBOARDING: `/${PATH_SEG.AUTH}/${PATH_SEG.ONBOARDING}`,

  REGISTER: `/${PATH_SEG.REGISTER}`,
  REGISTER_VERIFY: `/${PATH_SEG.REGISTER}/${PATH_SEG.VERIFY}`,
  REGISTER_COMPLETE: `/${PATH_SEG.REGISTER}/${PATH_SEG.COMPLETE}`,

  RESET: `/${PATH_SEG.RESET}`,
  RESET_PASSWORD: `/${PATH_SEG.RESET}/${PATH_SEG.PASSWORD}`,
  RESET_VERIFY: `/${PATH_SEG.RESET}/${PATH_SEG.VERIFY}`,

  GO_PLASTAR: `/${PATH_SEG.GO}/${PATH_SEG.PLASTAR}`,
  GO_NERA: `/${PATH_SEG.GO}/${PATH_SEG.NERA}`,

  ERROR: `/${PATH_SEG.ERROR}`,

  // [PRIVATE]
  DASHBOARD: `/${PATH_SEG.DASHBOARD}`,
  USER_NOTIFICATION: `/${PATH_SEG.USER_NOTIFICATION}/${PATH_PARAM.SILO_ID}`,

  SILOBAG_LIST: `/${VERSION.V2}/${PATH_SEG.SILOBAG_LIST}`,
  SILOBAG: `/${PATH_SEG.SILOBAG}`,
  SILOBAG_NEW: `/${PATH_SEG.SILOBAG}/${PATH_SEG.NEW}`,
  SILOBAG_INSURANCE: `/${PATH_SEG.SILOBAG}/${PATH_SEG.INSURANCE}/${PATH_PARAM.SILO_IDS}`,
  SILOBAG_CORVUS: `/${PATH_SEG.SILOBAG}/${PATH_SEG.CORVUS}/${PATH_PARAM.SILO_ID}`,
  SILOBAG_ARCHIVED: `/${PATH_SEG.SILOBAG}/${PATH_SEG.ARCHIVED}`,
  SILOBAG_DETAIL: `/${PATH_SEG.SILOBAG}/${PATH_PARAM.SILO_ID}`,
  SILOBAG_EDIT: `/${PATH_SEG.SILOBAG}/${PATH_PARAM.SILO_ID}/${PATH_SEG.EDIT}`,

  REPORT_STOCK: `/${PATH_SEG.REPORT}/${PATH_SEG.STOCK}`,
  REPORT_ALERT: `/${PATH_SEG.REPORT}/${PATH_SEG.ALERT}`,
  REPORT_DEVICE: `/${PATH_SEG.REPORT}/${PATH_SEG.DEVICE}`,
  REPORT_STATE_STOCK: `/${PATH_SEG.REPORT}/${PATH_SEG.STATE_STOCK}`,
  REPORT_ACTIVITY: `/${PATH_SEG.REPORT}/${PATH_SEG.ACTIVITY}`,
  REPORT_EXISTENCE: `/${PATH_SEG.REPORT}/${PATH_SEG.EXISTENCE_REPORT}`,
  REPORT_POSITION_GENERAL: `/${PATH_SEG.REPORT}/${PATH_SEG.POSITION_GENERAL}`,

  MAP: `/${PATH_SEG.MAP}`,
  MAP_DETAIL: `/${PATH_SEG.MAP}/${PATH_PARAM.SILO_ID}`,

  INCONSISTENCIES: `/${PATH_SEG.INCONSISTENCIES}`,
  INCONSISTENCIES_DETAIL: `/${PATH_SEG.INCONSISTENCIES}/${PATH_PARAM.SILO_ID}`,

  ADMIN: `/${PATH_SEG.ADMIN}`,
  ADMIN_NOTIFICATION: `/${PATH_SEG.ADMIN}/${PATH_SEG.NOTIFICATION}/${PATH_PARAM.USER_ID}`,
  ADMIN_METRIC_ALERT_CONFIG: `/${PATH_SEG.ADMIN}/${PATH_SEG.METRIC_ALERT_CONFIG}`,
  ADMIN_WARRANTS: `/${PATH_SEG.ADMIN}/${PATH_SEG.WARRANTS}`,

  NO_CONNECTION: `/${PATH_SEG.NO_CONNECTION}`,
} as const;
